import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import en from './translations/en.json';
import es from './translations/es.json';
import ar from './translations/ar.json';
import fa from './translations/fa.json';
import ku from './translations/ku.json';
import ckb from './translations/ckb.json';
import ro from './translations/ro.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  ar: { translation: ar },
  fa: { translation: fa },
  ku: { translation: ku },
  ckb: { translation: ckb },
  ro: { translation: ro },
};

const supportedLngs = ['en', 'es', 'ar', 'fa', 'ku', 'ckb', 'ro'] as const;
const storedLng =
  typeof window !== 'undefined' ? window.localStorage.getItem('candle-language') : null;
const initialLng =
  storedLng && (supportedLngs as readonly string[]).includes(storedLng) ? storedLng : undefined;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: initialLng,
    supportedLngs: [...supportedLngs],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      order: ['localStorage', 'querystring', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'candle-language',
      lookupCookie: 'candle-language',
      cookieMinutes: 525600, // 1 year
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
